module.exports = __webpack_public_path__ + "img/talent-flow.9c8b6d89.png";